<template>
  <div id="tooltip-recipient">
    <div class="d-flex justify-content-end">
      <Button
        class="btn btn-color1"
        :class="parsedBtnClasses"
        :disabled="!isNewOrderAvailable"
        @click="createOrderOpen = !createOrderOpen"
      >
        {{ $t('include_budget') }}
      </Button>
    </div>
    <template v-if="!isNewOrderAvailable">
      <b-tooltip custom-class="font-size-xSmall" target="tooltip-recipient" triggers="hover">
        <p class="mb-0">{{ newOrderTooltipText }}</p>
      </b-tooltip>
    </template>
    <template v-if="user && createOrderOpen">
      <CreateOrder
        :company="user.company"
        :advertiser="advertiser"
        :reloadAdvertisers="reloadAdvertisers"
        @order-created="handleOrderCreated"
      />
    </template>
  </div>
</template>

<script>

import UsersService from '@/modules/users/services/users-service'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'
import CreateOrder from '@/components/orders/CreateOrder'

export default {
  name: 'CreateOrderButton',
  props: ['advertiser', 'reloadAdvertisers', 'btnClasses'],
  components: {
    Button,
    CreateOrder
  },
  data () {
    return {
      createOrderOpen: false
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    /**
     * Return if company is advertiser
     */
    isAdvertiser () {
      return this.user && this.user.company.type === 'ADVERTISER'
    },
    /**
     * Return if new order button should be available
     */
    isNewOrderAvailable () {
      if (!this.user) return false
      if (this.user.company.is_complete) return true
      if (this.isAdvertiser) return true
      if (!this.user.company.recipient_status && (this.user.role.slug !== 'user-manager' && this.user.role.slug !== 'administrator')) return false
      return true
    },
    /**
     * Text for the tooltip when new order button is disabled
     */
    newOrderTooltipText () {
      if (!this.user) return ''
      if (this.user.company.is_complete) return this.$t('alert_include_budget2')
      if (!this.user.company.recipient_status && (this.user.role.slug !== 'user-manager' && this.user.role.slug !== 'administrator')) return this.$t('alert_include_budget')
      return ''
    },
    parsedBtnClasses () {
      return this.btnClasses ? this.btnClasses : ''
    }
  },
  methods: {
    /**
     * Handle company updated
     */
    async handleCompanyUpdated () {
      await UsersService.me()
    },
    /**
     * Handle order created
     */
    handleOrderCreated (order) {
      // this.createOrderOpen = false
      this.$emit('order-created', order)
    },
    /**
     * Handle recipient created
     */
    async handleRecipientCreated () {
      await UsersService.me()
      this.$emit('recipient-created')
    }
  }
}
</script>
